import orgServices from '../../../services/notisphere/organization'
import SupplierModal from './SupplierModal'
import { ORGANIZATION_STATUS } from '../../../misc/commons'
import { _findObj } from '../../../misc/genericFunctions'
import { Notisphere_Supplier_AgGrid, AG_GridCustomizedTableHeaders_Key } from '../../../misc/tableHeaders'
import _ from 'lodash'
export default {
    components: {
        SupplierModal
    },
    data() {
        return {
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
            },
            search: {
                name: null,
                add1: null,
                add2: null,
                city: null,
                state: null,
                zip: null,
                stt: null,
            },
            gridApi: null,
            columnApi: null,
            searchQuery: { pageNumber: 1, pageSize: 500, sort: null, colId: null },
            total: 0,
            items: [],
            header: [],
            defaultHeader: [],
            org_status: ORGANIZATION_STATUS,
            supplierModalKey: 0,
            globalSearchText: '',
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
        }
    },
    created() {
        this.rowModelType = 'serverSide'
    },

    beforeMount() {
        this.columnDefs = Notisphere_Supplier_AgGrid
    },
    methods: {
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const searchquery = JSON.parse(JSON.stringify(this.searchQuery))
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email

                    // Handle status filter mapping for export
                    const statusFilter = params.api.getFilterModel()?.stt?.values
                    let mappedStatusFilter = null
                    if (statusFilter && statusFilter.length > 0) {
                        const statusMap = {
                            'Active': 'ACTIVE',
                            'Deactivated': 'DEACTIVATED',
                            'Pending': 'PENDING'
                        }
                        mappedStatusFilter = statusFilter.map(status => statusMap[status] || status)
                    }

                    const query_param = {
                        ...searchquery,
                        search: that.globalSearchText,
                        sortField: searchquery.colId,
                        sortDirection: searchquery.sort,
                        name: params.api.getFilterModel()?.name?.filter,
                        add1: params.api.getFilterModel()?.add1?.filter,
                        add2: params.api.getFilterModel()?.add2?.filter,
                        city: params.api.getFilterModel()?.city?.filter,
                        state: params.api.getFilterModel()?.state?.filter,
                        zip: params.api.getFilterModel()?.zip?.filter,
                        stt: mappedStatusFilter,
                        email: email,
                        filterModel: params.api.getFilterModel(),
                    }
                    const resp = await orgServices.downloadAgGridSupplierAccountXLSXRecall(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.Supplier_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.Supplier_Headers
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        },
        addMoreClick() {
            this.supplierModalKey += 1
            this.$nextTick(() => {
                this.$refs.supplierModal.forceRerenderInsert()
            })
        },
        onCellClicked(params) {
            if (params.colDef.field === 'status') {
                this.addMoreRespClick(params.data)
                return
            }
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'edit') {
                    this.updateSupplier(params.data.id)
                }
                if (params.event.target.dataset.action === 'delete') {
                    this.deletePendingSupplier(params.data)
                }
                return
            }else{
                this.supplierModalKey += 1
                this.$nextTick(() => {
                    this.$refs.supplierModal.forceRerenderUpdate(params.data.id)
                })
            }
        },
        // update supplier data
        updateSupplier(payload, e = null) {
            this.supplierModalKey += 1
            this.$nextTick(() => {
                this.$refs.supplierModal.forceRerenderUpdate(payload)
            })
            if (e) {
                e.stopPropagation()
            }
        },
        // end here
        fetchData(params) {
            this.applyState(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            // params.api.sizeColumnsToFit()
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.name = params.request?.filterModel?.name?.filter
                    that.search.add1 = params.request?.filterModel?.add1?.filter
                    that.search.add2 = params.request?.filterModel?.add2?.filter
                    that.search.city = params.request?.filterModel?.city?.filter
                    that.search.state = params.request?.filterModel?.state?.filter
                    that.search.zip = params.request?.filterModel?.zip?.filter

                    // Handle status filter mapping from display values to backend values
                    const statusFilter = params.request?.filterModel?.stt?.values
                    if (statusFilter && statusFilter.length > 0) {
                        const statusMap = {
                            'Active': 'ACTIVE',
                            'Deactivated': 'DEACTIVATED',
                            'Pending': 'PENDING'
                        }
                        that.search.stt = statusFilter.map(status => statusMap[status] || status)
                    } else {
                        that.search.stt = null
                    }

                    that.search.filterModel = that.gridApi.getFilterModel()
                    orgServices.findSuppliers({
                        ...that.searchQuery,
                        search: that.globalSearchText,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search
                    })
                        .then(resp => {
                            if (!resp.error) {
                                that.total = resp.data.d.t
                                return resp.data.d.c
                            }
                        }).then(response => {

                            params.successCallback(response)
                        })
                        .catch(error => {
                            console.error(error)
                            params.failCallback()
                        })
                }
            }
            // register datasource with the grid
            params.api.setServerSideDatasource(datasource)

        },
        deletePendingSupplier(item, e) {
            this._showConfirm('You are about to delete this organization, this cannot be undone.').then(confirm => {
                if (confirm) {
                    orgServices.deletePendingSupplier(item.id).then(resp => {
                        if (!resp.error) {
                            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                            this._showToast('Deleted successfully!')
                        }
                    })
                }
            })
            // e.stopPropagation()
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length >= 1) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        },
    }
}